import { styled, TableCell } from '@mui/material';

export const NoWrapTableCell = styled(TableCell)(() => ({
	whiteSpace: 'nowrap',
	overflow: 'hidden',
	textOverflow: 'ellipsis'
}));
